(function () {
  let loading = false;
  let failed = false;
  let openRequested = false;
  const launcher = document.querySelector('.rb-chat-launcher');
  const originalLabel = launcher && launcher.querySelector('span').textContent;
  function restoreLauncher() {
    if (!launcher) return;
    launcher.removeAttribute('aria-busy');
    launcher.querySelector('span').textContent = originalLabel;
  }
  function loadChat(open) {
    openRequested = openRequested || open;
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
      if (openRequested) window.Tawk_API.maximize();
      if (launcher) launcher.hidden = true;
      return;
    }
    if (loading || failed) return;
    loading = true;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    const previousLoad = window.Tawk_API.onLoad;
    window.Tawk_API.onLoad = function () {
      loading = false;
      restoreLauncher();
      if (launcher) launcher.hidden = true;
      if (typeof previousLoad === 'function') previousLoad();
      if (openRequested) window.Tawk_API.maximize();
    };
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/6763e5ae49e2fd8dfefa33f1/1iff3idel';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    script.onerror = function () {
      failed = true;
      loading = false;
      restoreLauncher();
    };
    document.head.appendChild(script);
  }
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[data-rb-chat]');
    if (!link || failed || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (launcher) {
      launcher.setAttribute('aria-busy', 'true');
      launcher.querySelector('span').textContent = launcher.dataset.loadingLabel;
    }
    try { sessionStorage.setItem('rb_chat_started', '1'); } catch (error) {}
    loadChat(true);
  });
  try {
    if (sessionStorage.getItem('rb_chat_started') === '1') {
      if (document.readyState === 'complete') loadChat(false);
      else window.addEventListener('load', function () { loadChat(false); }, {once: true});
    }
  } catch (error) {}
})();
const response = document.querySelector('.rb-help__personal [role="alert"], .rb-help__personal [role="status"]');
if (response) response.closest('details').open = true;
